import React from 'react'

function About() {
  return (
    <article className='about'>
        <h3>
        </h3>
    </article>
  )
}

export default About
